import React, { useEffect } from "react";
import { useStyle } from "./styles";
import CustomTable from "../../components/CustomTable";
import Provider from "./Provider";
import { Loader } from "../../services/helper";
import { useLocation } from "react-router-dom";
import AdminEditForm from "../../components/AllEditForms/AdminEditForm";

function AllAdmin(props) {
  const {
    allData,
    isLoading,
    setIsLoading,
    handleActive,
    handleApprove,
    handleEdit,
    handleDelete,
    openEdit,
    setOpenEdit,
    errors,
    fullName,
    setFullname,
    emailAddress,
    setEmailAddress,
    mobile_number,
    setMobile_Number,
    password,
    setPassword,
    accountStatus,
    profileStatus,
    preview,
    userName,
    setUserName,
    fillAcconutStatus,
    fillProfileStatus,
    handleAccount,
    handleProfile,
    handleImage,
    handleSubmit,
  } = Provider();
  const loc = useLocation().state;
  // console.log("ADMIN PROPSPS ::", loc);

  return (
    <>
      {isLoading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <CustomTable
            TableTitle={`All ${loc?.role} Information`}
            TableData={allData}
            handleActive={handleActive}
            handleApprove={handleApprove}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            role={loc?.role}
          />
          <AdminEditForm
            open={openEdit}
            close={setOpenEdit}
            fullName={fullName}
            setFullname={setFullname}
            emailAddress={emailAddress}
            setEmailAddress={setEmailAddress}
            mobile_number={mobile_number}
            setMobile_Number={setMobile_Number}
            userName={userName}
            setUserName={setUserName}
            password={password}
            setPassword={setPassword}
            preview={preview}
            fillAcconutStatus={fillAcconutStatus}
            fillProfileStatus={fillProfileStatus}
            errors={errors}
            accountStatus={accountStatus}
            profileStatus={profileStatus}
            handleAccount={handleAccount}
            handleImage={handleImage}
            handleProfile={handleProfile}
            handleSubmit={handleSubmit}
          />
        </>
      )}
    </>
  );
}

export default AllAdmin;
